import script from "./CancellationReasonsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CancellationReasonsView.vue?vue&type=script&setup=true&lang=ts"

import "./CancellationReasonsView.vue?vue&type=style&index=0&id=2a9d2553&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9d2553"]])

export default __exports__